var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-btn',{attrs:{"loading":"","small":"","tile":""}}):(_vm.data)?_c('RevealSample',{attrs:{"sample_uuid":_vm.sample_uuid,"hidden":Boolean(_vm.data.hidden)},on:{"refresh":_vm.getSample}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }